import useStyles from './styles';
import { IResultsContainerProps } from './types';

export default function ResultsContainer({ children }: IResultsContainerProps) {
  const classes = useStyles();

  return <div className={`${classes.resultsContainer} search-results`}>{children}</div>;
}
